import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { Map, GoogleApiWrapper, Marker } from "google-maps-react"


const MapContainer = () => {
  const data = useStaticQuery(graphql`
      query {
          company: directusCompany {
              latitude
              longitude
              maps_link
          }
      }
  `)

  const mapStyles = {
    width: '100%',
    height: '100%',
  };

  const onMarkerClick = () => {
    window.open(data.company.maps_link, "_blank")
  }

  return (
    <Map
      google={window.google}
      zoom={14}
      style={mapStyles}
      initialCenter={{ lat: data.company.latitude, lng: data.company.longitude}}
    >
      <Marker onClick={onMarkerClick} name={'Current location'} />
    </Map>
  );
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAzDeT2wFfIIsjVKRwm7eUi2oiE2D1MArw'
})(MapContainer);
